import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';

import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs, message, theme, CheckBox } from 'antd';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';



const Category = (props) => {

    const { api, userData, settingData, warehouseData, selectedCompany, categoryData,
        productData, refData, branchData, projectData, selectedYear,
        currencyData } = useContext(DataContext);


    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);
    const companyId = selectedCompany.id;
    const yearId = selectedYear.id;

    const { showModal, toggleModal, table, title, setSelectedCategory, isOrder, isDebit, idRow, type } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);


    return (
        <div className="card custom-scrollbar" style={{ width: '10%', margin: 0, padding: 0, overflowY: 'auto', overflowX: 'hidden'}} >
            {categoryData?.map((category, index) => (
                <div className="card" key={index} style={{
                        height: '7vh',
                        width: '90%',
                        marginLeft: 5,
                        marginRight: 5,
                        marginTop: 10,
                        marginBottom: 0,
                        textAlign: 'center', 
                        display: 'flex', 
                        justifyContent: 'center', 
                        alignItems: 'center', 
                        flexShrink: 0, 
                        backgroundColor: '#489bc1',
                        color: 'white',
                        fontSize: '18px',
                        fontWeight: '500',
                        cursor: 'pointer',
                    }}
                    onClick={() => setSelectedCategory(category?.id)}
                >
                    {category?.name}
                </div>
            ))}
        </div>

    )
}


export default Category;